import React from "react";
import { useTranslation } from "react-i18next";
import { Container, Row, Col } from "react-bootstrap";
import { FaPhoneAlt } from "react-icons/fa";

import "./style.css";

const Help = () => {
  const { t } = useTranslation();

  return (
    <section className="gauto-call-area section_70">
      <Container>
        <Row>
          <Col md={12}>
            <div className="call-box">
              <div className="call-box-inner">
                <h2>  
                  Drive the Wild in Comfort and Class
                </h2>
                <p>
                Don’t just travel through Tanzania — experience it in a luxury safari Land Cruiser built for performance and prestige. From rough park roads to scenic game drives, we deliver strength where it’s needed and comfort where it counts.
                </p>
                <div className="call-number">
                  <div className="call-icon">
                    <FaPhoneAlt />
                  </div>
                  <div className="call-text">
                    <p>Ready to start your safari journey?</p>
                    <h4>
                      <a href="tel:+255783339124">+255 783 339 124</a> |{" "}
                      <a href="tel:+255781800727">+255 781 800 727</a>
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Help;
